import { Instance, types as t, SnapshotOut } from 'mobx-state-tree';
import omit from 'lodash/omit';
import isString from 'lodash/isString';
import actions from './actions';
import model from './model';
import views from './views';

const ConnectivityWidgetStore = model.views(views).actions(actions);

export interface IConnectivityWidgetStore extends Instance<typeof ConnectivityWidgetStore> {}
export interface IConnectivityWidgetStoreSnapshotOut extends SnapshotOut<typeof ConnectivityWidgetStore> {}

export default t.snapshotProcessor(ConnectivityWidgetStore, {
  postProcessor(sn) {
    return omit(sn, ['nodes']);
  },
  preProcessor(values: any) {
    if (isString(values.node_id)) {
      return {
        ...values,
        node_id: [values.node_id]
      };
    }
    return values;
  }
});
